import { formatDateTime } from './journeyTime'
import { cancelKey, durationOf, joined, stateKey, wordsFor } from './journeyWords'
import {
  DEPOSIT_PAID,
  daysOpen,
  depositOf,
  isEnded,
  lastCustomerStep,
  lineMessagesOf,
  messagesSent
} from './afterOrderFacts'

const standingOf = (t, journey, lang) => {
  const after = journey.after_order
  const startedAt = journey.order?.started_at
  const state = wordsFor(journey, stateKey(after.state), lang)
  const date = formatDateTime(after.to, lang)
  const duration = durationOf(t, startedAt, after.to)
  const reason = after.state?.reason
  if (after.ends_by === 'paid') {
    return joined([
      t('orderJourney.afterPaid', { date, duration }),
      after.state?.kind !== 'paid' && t('orderJourney.stateNow', { state })
    ])
  }
  if (after.ends_by === 'cancelled') {
    return joined([
      t('orderJourney.afterCancelled', { date, duration }),
      reason && wordsFor(journey, cancelKey(reason), lang)
    ])
  }
  const count = daysOpen(startedAt, after.to)
  return t(after.ends_by === 'days' ? 'orderJourney.afterDays' : 'orderJourney.afterOpen', { count, state })
}

const afterSummaryText = (t, journey, lang) => {
  const after = journey.after_order
  if (!after) return null
  const steps = after.steps || []
  const open = !isEnded(after)
  const cut = after.complete === false
  const deposit = depositOf(steps)
  const lastStep = open && !cut && lastCustomerStep(steps)
  const last = lastStep && !(deposit && lastStep.name === DEPOSIT_PAID) && lastStep
  const sent = open ? messagesSent(steps) : 0
  const line = open ? lineMessagesOf(steps) : 0
  return joined([
    standingOf(t, journey, lang),
    deposit && t('orderJourney.afterDeposit', { date: formatDateTime(deposit.first_at, lang) }),
    last && t('orderJourney.lastStep', { date: formatDateTime(last.at, lang), step: wordsFor(journey, last.name, lang) }),
    sent > 0 && t(cut ? 'orderJourney.weSentAtLeast' : 'orderJourney.weSentCount', { count: sent }),
    line > 0 && t(cut ? 'orderJourney.lineCountAtLeast' : 'orderJourney.lineCount', { count: line })
  ])
}

export { standingOf, afterSummaryText }
